module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchOnYouTube":"Search on YouTube","tryAgain":"TRY AGAIN"},"ja":{"searchOnYouTube":"YouTube で検索","tryAgain":"もう一回"},"zh-Hant":{"searchOnYouTube":"在 YouTube 上搜尋","tryAgain":"再抽一次"},"zh-Hans":{"searchOnYouTube":"在 YouTube 上搜索","tryAgain":"再抽一次"}}')
  delete Component.options._Ctor
}
